const field = {
  inject: ['parentValidator'],
  data() {
    return {
      answer: this.fieldArray ? [] : '',
      id: null,
      groupFieldName: this.fieldArray ? this.fieldArray[0].name : '',
      initialValue: '',
    };
  },
  created() {
    this.$validator = this.parentValidator;
  },
  mounted() {
    this.id = (Math.random() + 1).toString(36).substring(7);

    if (this.initial) {
      if (typeof this.mobileString !== 'undefined') {
        this.updateMobileField(this.initial);
        this.answer = this.mobile.number;
      } else {
        this.answer = this.initial;
      }
    }

    if (this.initialStoreName) {
      this.$store.commit('setSelectedStoreName', this.initialStoreName);
    }
  },
  methods: {
    getFieldId(name) {
      return `field-${name}-${this.id}`;
    },
    updateValue() {
      this.$emit('input', this.answer);
    },
    updateStoreValue(storeName) {
      this.$emit('input', this.answer);
      this.$store.commit('setSelectedStoreName', storeName);
    },
    getErrorMsg(name) {
      const customMsg = name ? `Please enter a valid ${name.replace(/-/g, ' ')}.` : '';

      return this.errorMsg ? this.errorMsg : customMsg;
    },
  },
};

export { field as default };
